var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents_855"},[_c('div',[_c('h1',{staticClass:"title2"},[_vm._v("プラン変更完了")]),_c('div',{staticClass:"contents_box mg20"},[_c('p',{staticClass:"mypage_notes mg30 mg_bt30 font_orange"},[_vm._v(" プラン変更が完了しました。 ")])])])])
}]

export { render, staticRenderFns }